import { useState } from 'react';
import Banner from '../../Components/Layout/Banner/Banner.js';
import '../Fields/Fields.css';

function Fields() {
    // 기본값을 '형사'로 설정
    const [selectedCategory, setSelectedCategory] = useState('형사');

    const categories = ['형사', '민사', '가사', '상속', '성범죄', '기타'];

    return (
        <>
            <Banner />
            <div className="fields-page-wrapper py-5 container">
                {/* 카테고리 필터 버튼 영역 */}
                <div className="category-filter-wrapper mb-5 text-center">
                    {categories.map((cat) => (
                        <button
                            key={cat}
                            className={`btn filter-btn ${selectedCategory === cat ? 'active' : ''}`}
                            onClick={() => setSelectedCategory(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                {/* 필터 결과 영역 */}
                <div className="fields-content-area shadow-sm p-4 p-md-5 border rounded bg-white">
                    <div className="content-header mb-4">
                        <span className="badge bg-gold mb-2">{selectedCategory}</span>
                        <h2 className="fw-bold">{selectedCategory} 분야 안내</h2>
                    </div>

                    <div className="content-body text-secondary">
                        {/* 카테고리별 상세 내용 */}
                        {selectedCategory === '형사' && (
                            <div>
                                <p>경찰 수사 단계부터 재판까지, 피의자 및 피고인의 권리 보호를 위해 최선을 다합니다.</p>
                                <ul>
                                    <li>일반 형사 사건 (폭행, 절도 등)</li>
                                    <li>경제 범죄 (사기, 횡령, 배임)</li>
                                    <li>교통 사고 및 음주 운전</li>
                                </ul>
                            </div>
                        )}

                        {/* 다른 카테고리별 조건부 렌더링 예시 */}
                        {selectedCategory === '민사' && (
                            <p>손해배상, 대여금, 부동산 관련 분쟁 등 복잡한 이해관계를 명확하게 해결해 드립니다.</p>
                        )}

                        {/* 준비 중인 카테고리 처리 */}
                        {selectedCategory !== '형사' && selectedCategory !== '민사' && (
                            <p>{selectedCategory} 분야에 대한 상세 소개 내용이 곧 업데이트될 예정입니다.</p>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Fields;